import React from "react";
import { Link } from "react-router-dom";

import { ReactComponent as ArrowIcon } from "../../assets/images/arrow-right.svg";

/**
 * Summary of one table in the /orders list.
 *
 * The whole card is the link, not a word at the bottom of it: it sits directly
 * beneath .order-card rows, which are links themselves, and a card-sized target
 * is what a thumb expects there.
 */
const TableCard = ({ table }) => {
  const filled = table.capacity - table.seatsRemaining;
  const filledRatio = table.capacity > 0 ? filled / table.capacity : 0;
  const open = table.seatsRemaining > 0;

  return (
    <Link
      className="table-card"
      to={`/tables/${table.code}`}
      aria-label={`${open ? "Add your guests" : "Manage guests"} for table ${
        table.code
      }. ${filled} of ${table.capacity} seats filled.`}
    >
      <div className="table-card__body">
        <div className="table-card__event">{table.eventName}</div>
        <div className="table-card__meta">
          <span className="table-card__code">Table {table.code}</span>
          <span className="table-card__seats">
            {filled} of {table.capacity} seats filled
          </span>
          {table.assignedLabel ? <span>{table.assignedLabel}</span> : null}
        </div>
        <div className="table-card__progress" aria-hidden="true">
          <div
            className="table-card__progress-fill"
            style={{ transform: `scaleX(${filledRatio})` }}
          />
        </div>
      </div>
      <span className="table-card__cta" aria-hidden="true">
        <span className="table-card__cta-label">
          {open ? "Add guests" : "Manage"}
        </span>
        <ArrowIcon />
      </span>
    </Link>
  );
};

export default TableCard;
